module.exports = __webpack_public_path__ + "img/纬度.286b47f5.svg";